import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import Home from "../pages/Home";
import Products from "../pages/Products";
import Packages from "../pages/Packages";
import Contact from "../pages/Contact";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import Cart from "../pages/Cart";
import AllOrders from "../adminpanel/Orders";
import AdminLogin from "../adminpanel/AdminLogin";
import AdminPanel from "../adminpanel/AdminPanel";
import AdminDashboard from "../adminpanel/AdminDashboard";
import AllProducts from "../adminpanel/AllProducts";
import AllPackages from "../adminpanel/AllPackages";
import UserProfile from "../pages/UserProfile";
import AllPlans from "../adminpanel/AllPlans";
import EditOrders from "../adminpanel/EditOrders";
import AllCustomers from "../adminpanel/AllCustomers";
import PersonalDashboard from "../adminpanel/PersonalDashboard";
import { Toaster } from "react-hot-toast";
import MyOrders from "../pages/MyOrders";
import ProductDetails from "../pages/ProductDetails";
import MySubscriptions from "../pages/MySubscriptions";
import VendingMechine from "../adminpanel/VendingMechine";
import Organization from "../adminpanel/Organization";
import SponsorshipPage from "../pages/SponsorShip";
import SakhiCheckout from "../pages/SakhiCheckout";
import SakhiReport from "../adminpanel/SakhiReport";
import UploadExcel from "../adminpanel/UploadExcel";
import Settings from "../pages/Settings";
import AllOrganizationCustomers from "../adminpanel/AllOrganizationCustomer";
import AllProductsPackage from "../adminpanel/AllProductsPackage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import RefundPolicy from "../pages/RefundPolicy";
import TermsandConditions from "../pages/TermsandConditions";
import CustomerReviews from "../adminpanel/CustomerReviews";
import Faqs from "../pages/Faqs";
import AssignCoupons from "../adminpanel/AssignCoupons";
import CouponCreate from "../adminpanel/CouponCreate";
import ReferralsReport from "../adminpanel/ReferralsReport";
import OrderSuccess from "../pages/OrderSuccess";
import EntryCouponCreate from "../adminpanel/EntryCouponCreate";
import AdminPasswordReset from "../adminpanel/AdminPasswordReset";
import Articles from "../pages/Articles";
import ProductDimentions from "../adminpanel/ProductDimentions";
const PrivateAdminRoute = ({ children }) => {
  const sessionItem = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
  if (!sessionItem) {
    return <Navigate to="/admin-login" replace />;
  }
  try {
    atob(sessionItem);
    return children;
  } catch {
    sessionStorage.removeItem("H7Z4L9VD2XK5JW8QRYT6");
    return <Navigate to="/admin-login" replace />;
  }
};

const AppRoutes = () => {
  return (
    <>
   <Toaster
         position="top-center"
         containerStyle={{ top: 80 }}
         toastOptions={{
           style: { zIndex: 99999 },
           // Force 1 second for Mobile, 2.5 seconds for Desktop
           duration: window.innerWidth < 768 ? 1000 : 2500,
         }}
       />
      <Routes>
        {/* Public Routes with Layout */}
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Layout>
                         
              <PrivacyPolicy />
                          
            </Layout>
          }
        />
              <Route
        path="/articles"
        element={
          <Layout>
            <Articles />
          </Layout>
        }
      />  
        <Route
          path="/refund-policy"
          element={
            <Layout>
                         
              <RefundPolicy />
                          
            </Layout>
          }
        />
                
        <Route
          path="/terms-conditions"
          element={
            <Layout>
                   
              <TermsandConditions />
                          
            </Layout>
          }
        />
        <Route
          path="/products"
          element={
            <Layout>
              <Products />
            </Layout>
          }
        />
        <Route
          path="/packages"
          element={
            <Layout>
              <Packages />
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />
        <Route
          path="/login"
          element={
            <Layout>
              <Login />
            </Layout>
          }
        />
        <Route
          path="/signup"
          element={
            <Layout>
              <Signup />
            </Layout>
          }
        />
        <Route
          path="/cart"
          element={
            <Layout>
              <Cart />
            </Layout>
          }
        />
         <Route
          path="/order-success"
          element={
            <Layout>
             <OrderSuccess/>
            </Layout>
          }
        />
        <Route
          path="/profile"
          element={
            <Layout>
              <UserProfile />
            </Layout>
          }
        />
        <Route
          path="/my-orders"
          element={
            <Layout>
              <MyOrders />
            </Layout>
          }
        />
        <Route
          path="/my-subscriptions"
          element={
            <Layout>
              <MySubscriptions />
            </Layout>
          }
        />
        <Route
          path="/sakhi-sponsor"
          element={
            <Layout>
              <SponsorshipPage />
            </Layout>
          }
        />
        <Route
          path="/sakhi-checkout"
          element={
            <Layout>
              <SakhiCheckout />
            </Layout>
          }
        />
        <Route
          path="/sakhi-checkout"
          element={
            <Layout>
              <SakhiCheckout />
            </Layout>
          }
        />
        <Route
          path="/settings"
          element={
            <Layout>
              <Settings />
            </Layout>
          }
        />
        <Route
          path="/faqs"
          element={
            <Layout>
              <Faqs />
            </Layout>
          }
        />
        <Route
          path="/product/:id"
          element={
            <Layout>
              <ProductDetails />
            </Layout>
          }
        />
        {/* Admin Login - Public */}
        <Route path="/admin-login" element={<AdminLogin />} />
        {/* Protected Admin Panel - All sub-routes handled inside AdminPanel */}
        <Route
          path="/admin-panel/*"
          element={
            <PrivateAdminRoute>
              <AdminPanel />
            </PrivateAdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="products-package" element={<AllProductsPackage />} />
          <Route path="products" element={<AllProducts />} />
          <Route path="packages" element={<AllPackages />} />
          <Route path="plans" element={<AllPlans />} />
          <Route path="customers" element={<AllCustomers />} />
          <Route
            path="organization-customers"
            element={<AllOrganizationCustomers />}
          />
          <Route path="personaldashboard/:id" element={<PersonalDashboard />} />
          <Route path="orders" element={<AllOrders />} />
          <Route path="edit-orders/:id" element={<EditOrders />} />
          <Route path="vendingmechine" element={<VendingMechine />} />
          <Route path="organization" element={<Organization />} />
          <Route path="sakhi" element={<SakhiReport />} />
          <Route path="upload-excel" element={<UploadExcel />} />
          <Route path="customer-reviews" element={<CustomerReviews />} />
          <Route path="coupon-create" element={<CouponCreate />} />
          <Route path="entry-coupons" element={<EntryCouponCreate />} />
          <Route path="referrals" element={<ReferralsReport />} />
          <Route path="admin-password-reset" element={<AdminPasswordReset />} />
          <Route path="product-dimensions" element={<ProductDimentions />} />
        </Route>
        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
